import { render, staticRenderFns } from "./ProcessingQueue.vue?vue&type=template&id=899ab49a&scoped=true"
import script from "./ProcessingQueue.vue?vue&type=script&lang=ts"
export * from "./ProcessingQueue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899ab49a",
  null
  
)

export default component.exports